import React from 'react';
import {Navigate, Outlet} from 'react-router-dom';
import {useAppSelector} from '../store/store';

export const ProtectedRoute: React.FunctionComponent<{
    redirectPath?: string;
    children?: React.ReactNode;
}> = ({redirectPath = '/login', children}) => {
    const token = useAppSelector((state) => state.exchangeToken.token);
    if (!token) {
        return <Navigate to={redirectPath} replace />;
    }

    return children ? children : <Outlet />;
};
